import { useState, useEffect, useRef } from "react";
import { Header } from "../../common/Header/Header.jsx";
import {
  FleetIncidenceTable,
  FleetMaintenanceTable,
} from "../../common/Tables/Tables.jsx";
import {
  fleetIncidenceTableHeader,
  fleetManteinanceTableHeader,
} from "../../../assets/helpers/tables.js";
import { notify } from "../../../assets/helpers/toast.js";
import {
  FilterDatePicker,
  OneOptionTableFilter,
} from "../../common/Forms/Input/Input.jsx";
import moment from "moment";
import {
  filterParams,
  isValidMongoId,
} from "../../../assets/helpers/funciones.js";
import { LoadSpinner } from "../../common/LoadSpinner/LoadSpinner.jsx";
import * as schemas from "../../../assets/schemas/schemas.js";
import { yupResolver } from "@hookform/resolvers/yup";
import "./FleetMaintenance.scss";
import { ActionButton } from "../../common/Buttons/Buttons.jsx";
import { fleetService } from "../../../services/fleetService.js";
import { vehicularAssetsService } from "../../../services/vehicularAssetsService.js";
import { useForm } from "react-hook-form";
import {
  CreateFleetIncidenceModal,
  CreateFleetMaintenanceModal,
  EditFleetIncidenceModal,
  EditFleetMaintenanceModal,
} from "../../common/Modals/Modals.jsx";
import { operationsRoles } from "../../../assets/helpers/roles.js";
import { usersService } from "../../../services/usersService.js";
import { providersService } from "../../../services/providersService.js";

const itemsPerpage = [10, 25, 50, 100, 500];

const FleetMaintenance = () => {
  const tableRef = useRef(null);

  const {
    register,
    handleSubmit,
    errors,
    watch,
    control,
    setValue,
    getValues,
    reset,
  } = useForm({
    resolver: yupResolver(schemas.fleetMaintenanceSchema()),
  });

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    errors: errors2,
    setValue: setValue2,
    watch: watch2,
    getValues: getValues2,
    control: control2,
    reset: reset2,
  } = useForm({
    resolver: yupResolver(schemas.editFleetMaintenanceSchema()),
  });

  const {
    register: register3,
    handleSubmit: handleSubmit3,
    getValues: getValues3,
    errors: errors3,
    watch: watch3,
    control: control3,
    setValue: setValue3,
    reset: reset3,
  } = useForm({
    resolver: yupResolver(schemas.fleetIncidenceSchema()),
  });

  const {
    register: register4,
    handleSubmit: handleSubmit4,
    errors: errors4,
    setValue: setValue4,
    watch: watch4,
    getValues: getValues4,
    control: control4,
    reset: reset4,
  } = useForm({
    resolver: yupResolver(schemas.editFleetIncidenceSchema()),
  });

  const [userOptions, setUserOptions] = useState([]);
  const [internalProvidersOptions, setInternalProvidersOptions] = useState([]);
  const [fleetUnits, setFleetUnits] = useState([]);
  const [systems, setSystems] = useState([]);
  const [maintenanceProviders, setMaintenanceProviders] = useState([]);
  const [maintenanceProvidersOptions, setMaintenanceProvidersOptions] =
    useState([]);
  const [components, setComponents] = useState([]);
  const [fleetsUnitOptions, setFleetUnitOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openEditFleetMaintenanceModal, setOpenEditFleetMaintenanceModal] =
    useState({
      isOpen: false,
      maintenance: {},
    });
  const [openCreateFleetMaintenanceModal, setOpenCreateFleetMaintenanceModal] =
    useState(false);

  const [openEditFleetIncidenceModal, setOpenEditFleetIncidenceModal] =
    useState({
      isOpen: false,
      maintenance: {},
    });
  const [openCreateFleetIncidenceModal, setOpenCreateFleetIncidenceModal] =
    useState(false);
  const [originalFleetUnits, setOriginalFleetUnits] = useState([]);
  const [dateFrom, setDateFrom] = useState(
    new Date(moment().subtract(1, "months"))
  );
  const [unitParam, setUnitParam] = useState("All");
  const [driverParam, setDriverParam] = useState("All");
  const [unitTypeParam, setUnitTypeParam] = useState("All");
  const [dateTo, setDateTo] = useState(new Date(moment()));
  const [fleetMaintenanceTable, setFleetMaintenanceTable] = useState({
    limit: itemsPerpage[2],
    offset: 0,
    data: [],
    count: 0,
    page: 1,
    dateFrom: "",
    dateTo: "",
    isLoading: false,
    searchParam: "",
    type: "maintenance",
  });

  const handleUnitTypeParam = (e) => {
    setUnitTypeParam(e);

    const updatedUnits =
      e === "All"
        ? originalFleetUnits
        : originalFleetUnits.filter((item) => item.class === e.toUpperCase());

    setFleetUnits(updatedUnits);
    setUnitParam("All");
    if (fleetMaintenanceTable.type === "incidence") {
      setDriverParam("All");
    }
  };

  const createFleetMaintenance = handleSubmit(async (data) => {
    if (!isLoading) {
      setIsLoading(true);

      data.creationDate = moment(data.creationDate).toISOString();
      data.dateIn = moment(data.dateIn).toISOString();

      if (data.dateOut) {
        data.dateOut = moment(data.dateOut).toISOString();
      } else {
        delete data.dateOut;
      }

      if (data.comment === "") {
        delete data.comment;
      }

      if (data.type) {
        data.type = data.type.toUpperCase();
      }

      if (data.provider) {
        const foundProvider = maintenanceProviders.find(
          (item) => item._id === data.provider
        );

        if (foundProvider) {
          data.provider = foundProvider._id;
        } else {
          data.newProvider = data.provider;
          delete data.provider;
        }
      }

      fleetService
        .createMaintenance(data)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Mantenimiento de flota creado con exito`, "success");

            setIsLoading(false);
            getFleetData();
            setOpenCreateFleetMaintenanceModal(false);
            getMaintenanceProviders();
            reset();
          } else {
            notify(`${response.message}`, "error");
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });

  const createFleetIncidence = handleSubmit3(async (data) => {
    if (!isLoading) {
      setIsLoading(true);

      data.registrationDate = moment(data.registrationDate).toISOString();
      data.accidentDate = moment(data.accidentDate).toISOString();

      if (data.detail === "") {
        delete data.detail;
      }
      fleetService
        .createIncidence(data)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Incidencia de flota creado con exito`, "success");

            setIsLoading(false);
            getFleetData();
            setOpenCreateFleetIncidenceModal(false);
            reset3();
          } else {
            notify(`${response.message}`, "error");
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });

  const preloadEditForm = (maintenance) => {
    setValue2("type", maintenance?.type || "");
    setValue2("id", maintenance?._id || "");
    setValue2("createdBy", maintenance?.createdBy || "");
    setValue2("unit", maintenance?.unit?._id || "");
    setValue2("approvedBy", maintenance?.approvedBy || "");
    setValue2("type", maintenance?.type || "");
    setValue2("creationDate", new Date(maintenance?.createdAt) || "");
    setValue2("systemId", maintenance?.systemId?._id || "");
    setValue2("componentId", maintenance?.component?._id || "");
    setValue2("cost", maintenance?.cost || "");
    setValue2("provider", maintenance?.provider?._id || "");
    if (maintenance?.dateIn) {
      setValue2("dateIn", new Date(maintenance?.dateIn) || "");
    }
    if (maintenance?.dateOut) {
      setValue2("dateOut", new Date(maintenance?.dateOut) || "");
    }
    setValue2("km", maintenance?.km || "");
    setValue2("comment", maintenance?.comment || "");
    setValue2("unitStatus", maintenance?.unitStatus || "");
    setValue2("maintenanceType", maintenance?.maintenanceType || "");
  };

  const preloadEditIncidenceForm = (incidence) => {
    setValue4("unitType", incidence?.unitType || "");
    setValue4("id", incidence?._id || "");
    setValue4("registeredBy", incidence?.registeredBy?._id || "");
    setValue4("unit", incidence?.unit || "");
    setValue4("driver", incidence?.driver?._id || "");
    setValue4("accidentLocation", incidence?.accidentLocation || "");
    if (incidence.accidentDate) {
      setValue4("accidentDate", new Date(incidence?.accidentDate) || "");
    }
    if (incidence.registrationDate) {
      setValue4(
        "registrationDate",
        new Date(incidence?.registrationDate) || ""
      );
    }
    setValue4("detail", incidence?.detail || "");
    setValue4("unitStatus", incidence?.unitStatus || "");
  };

  const editFleetMaintenance = handleSubmit2(async (data) => {
    if (!isLoading) {
      setIsLoading(true);

      data.creationDate = moment(data.creationDate).toISOString();
      data.dateIn = moment(data.dateIn).toISOString();
      data.dateOut = moment(data.dateOut).toISOString();
      data.type = data.type.toUpperCase();

      delete data.type;
      delete data.id;

      if (data.provider) {
        const foundProvider = maintenanceProviders.find(
          (item) => item._id === data.provider
        );

        if (foundProvider) {
          data.provider = foundProvider._id;
        } else {
          data.newProvider = data.provider;
          delete data.provider;
        }
      }

      fleetService
        .EditMaintenance(watch2("id"), data)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Mantenimiento de flota creado con exito`, "success");

            setIsLoading(false);
            getFleetData();
            setOpenEditFleetMaintenanceModal((prevState) => ({
              ...prevState,
              isOpen: false,
            }));
            getMaintenanceProviders();
            reset2();
          } else {
            notify(`${response.message}`, "error");
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });

  const editFleetIncidence = handleSubmit4(async (data) => {
    if (!isLoading) {
      setIsLoading(true);

      data.registrationDate = moment(data.registrationDate).toISOString();
      data.accidentDate = moment(data.accidentDate).toISOString();

      if (data.detail === "") {
        delete data.detail;
      }
      delete data.unitType;
      delete data.id;

      fleetService
        .EditIncidence(watch4("id"), data)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Incidencia de flota creado con exito`, "success");

            setIsLoading(false);
            getFleetData();
            setOpenEditFleetIncidenceModal((prevState) => ({
              ...prevState,
              isOpen: false,
            }));
            reset4();
          } else {
            notify(`${response.message}`, "error");
            setIsLoading(false);
          }
        })
        .catch((error) => {
          setIsLoading(false);
        });
    }
  });

  const getUsers = () => {
    let params = {
      limit: 20,
      offset: 0,
      module: "Operaciones",
      role: operationsRoles.operationsAdmin,
    };

    usersService
      .getUsers(params)
      .then((response) => {
        if (response.status === 200) {
          response.data.users.map((user) => {
            return (user.name = `${user.firstName} ${user.lastName}`);
          });
          setUserOptions(response.data.users);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => {});
    return true;
  };

  const getinternalProviders = (type) => {
    let params = {
      limit: 100,
      offset: 0,
      isInternal: true,
      type: type,
    };

    if (params.type === "GRÚA") {
      params.type = "Grua";
    } else if (params.type === "MOTO") {
      params.type = "Asistente Vial";
    } else {
      delete params.type;
    }

    providersService.getProvidersByType(params).then((response) => {
      if (response.status === 200) {
        response.data.providers.map((provider) => {
          return (provider.name = provider.contactName);
        });
        response.data.providers.unshift({
          _id: "All",
          name: "Todos",
        });
        setInternalProvidersOptions(response.data.providers);
      } else {
        notify(`${response.message}` || "error", "error");
      }
    });
    return true;
  };

  const handleUnitParam = (e) => {
    setUnitParam(e);
  };

  const handleDriverParam = (e) => {
    setDriverParam(e);
  };

  const setFirstPage = () => {
    setFleetMaintenanceTable((prevState) => {
      return {
        ...prevState,
        page: 1,
        offset: 0,
      };
    });
  };

  const handleSinceDateChange = (e) => {
    if (e > dateTo && dateTo) {
      notify("Ingrese una fecha en un rango valido ", "info");
    } else {
      setFirstPage();
      setDateFrom(e);
    }
  };

  const handleUntilDateChange = (e) => {
    if (e < dateFrom && dateFrom) {
      notify("Ingrese una fecha en un rango valido ", "info");
    } else {
      setDateTo(e);
      setFirstPage();
    }
  };

  const handlePageChange = (event, value) => {
    setFleetMaintenanceTable((prevState) => {
      return {
        ...prevState,
        page: value,
        offset: (value - 1) * fleetMaintenanceTable?.limit,
      };
    });
  };

  const handleTableTypeSelected = (type) => {
    setFleetMaintenanceTable((prevState) => ({ ...prevState, type }));
    setUnitParam("All");
    setDriverParam("All");
    setUnitTypeParam("All");
  };

  useEffect(() => {
    getFleetData();
  }, [
    fleetMaintenanceTable?.page,
    fleetMaintenanceTable?.offset,
    fleetMaintenanceTable?.limit,
    fleetMaintenanceTable?.type,
    dateFrom,
    dateTo,
    unitParam,
    unitTypeParam,
    driverParam,
  ]);

  const getFleetUnits = () => {
    let params = {
      limit: 100,
      offset: 0,
    };
    vehicularAssetsService
      .getVehicularAssets(params)
      .then((response) => {
        if (response.status === 200) {
          setOriginalFleetUnits(response?.data?.vehicularAssets);
          setFleetUnits(response?.data?.vehicularAssets);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => {});
  };

  const getSystems = () => {
    let params = {
      type: "GRÚA",
    };
    fleetService
      .getSystems(params)
      .then((response) => {
        if (response.status === 200) {
          setSystems(response.data);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => {});
  };

  const getMaintenanceProviders = () => {
    let params = {
      offset: 0,
      limit: 100,
      isActive: true,
    };
    fleetService
      .getMaintenanceProviders(params)
      .then((response) => {
        if (response.status === 200) {
          setMaintenanceProviders(response.data.maintenanceProviders);
          setMaintenanceProvidersOptions(
            response.data.maintenanceProviders.map((item) => {
              return {
                _id: item._id,
                name: item.description,
              };
            })
          );
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => {});
  };

  const getComponents = (system) => {
    let params = {
      system: system,
    };
    fleetService
      .getComponents(params)
      .then((response) => {
        if (response.status === 200) {
          setComponents(response.data);
        } else {
          notify(`${response.message}` || "error", "error");
        }
      })
      .catch((error) => {});
  };

  const getFleetData = () => {
    let params = {
      unit: unitParam,
      unitType: unitTypeParam,
      dateFrom: dateFrom
        ? moment(dateFrom).format("MM-DD-YYYY")
        : moment().subtract(1, "months").format("MM-DD-YYYY"),
      dateTo: dateTo
        ? moment(dateTo).format("MM-DD-YYYY")
        : moment().format("MM-DD-YYYY"),
      limit: fleetMaintenanceTable?.limit,
      offset: fleetMaintenanceTable?.offset,
    };

    if (params?.unit === "All") {
      delete params.unit;
    }
    if (params?.unitType === "All") {
      delete params.unitType;
    }

    if (fleetMaintenanceTable.type === "incidence") {
      params.driver = driverParam;

      if (params.driver === "All") {
        delete params.driver;
      }
    }

    if (fleetMaintenanceTable.type === "incidence") {
      fleetService
        .getFleetIncidences(filterParams(params))
        .then((response) => {
          if (response.status === 200) {
            setFleetMaintenanceTable((prevState) => {
              return {
                ...prevState,
                data: response?.data?.fleetIncidence,
                count: response?.data?.total,
                isLoading: false,
              };
            });
          } else {
            notify(`${response.message}` || "error", "error");
            setFleetMaintenanceTable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          }
        })
        .catch((error) => {
          setFleetMaintenanceTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        });
    } else {
      fleetService
        .getFleetMaintenances(filterParams(params))
        .then((response) => {
          if (response.status === 200) {
            setFleetMaintenanceTable((prevState) => {
              return {
                ...prevState,
                data: response?.data?.fleetMaintenance,
                count: response?.data?.total,
                isLoading: false,
              };
            });
          } else {
            notify(`${response.message}` || "error", "error");
            setFleetMaintenanceTable((prevState) => {
              return {
                ...prevState,
                isLoading: false,
              };
            });
          }
        })
        .catch((error) => {
          setFleetMaintenanceTable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        });
    }

    return true;
  };

  const handleEditMaintenance = (maintenance) => {
    preloadEditForm(maintenance);
    setOpenEditFleetMaintenanceModal((prevstate) => ({
      ...prevstate,
      isOpen: true,
      maintenance,
    }));
  };

  const handleEditIncidence = (incidence) => {
    preloadEditIncidenceForm(incidence);
    setOpenEditFleetIncidenceModal((prevstate) => ({
      ...prevstate,
      isOpen: true,
      incidence,
    }));
  };

  const loadFleetUnitOptions = () => {
    let options = [
      {
        _id: "All",
        name: "Todos",
      },
    ];
    for (let i = 0; i < fleetUnits.length; i++) {
      options.push({
        _id: fleetUnits[i]?._id,
        name: `${fleetUnits[i]?.alias} - ${fleetUnits[i]?.plate}`,
        class: fleetUnits[i]?.class,
      });
    }
    setFleetUnitOptions(options);
  };

  const chooseOnlyTows = (unit) => {
    const filteredOptions = originalFleetUnits.filter(
      (item) => item?.class?.toUpperCase() === unit?.toUpperCase()
    );

    let editedNamePlate = [];

    filteredOptions.forEach((item) => {
      item.name = `${item.alias} - ${item.plate.toUpperCase()}`;

      editedNamePlate.push(item);
    });
    return editedNamePlate;
  };

  const loadMaintenanceHeaderFilters = () => {
    let header;

    if (fleetMaintenanceTable.type === "maintenance") {
      header = fleetManteinanceTableHeader.map((item) => {
        if (item.name === "Unidad") {
          return {
            ...item,
            name: (
              <OneOptionTableFilter
                label={"Unidad"}
                name={"unit"}
                placeholder={""}
                options={fleetsUnitOptions}
                onChange={handleUnitParam}
              />
            ),
          };
        } else if (item.name === "Tipo de unidad") {
          return {
            ...item,
            name: (
              <OneOptionTableFilter
                label={"Tipo de unidad"}
                name={"unitType"}
                placeholder={""}
                options={[
                  {
                    _id: "All",
                    name: "Todos",
                  },
                  {
                    _id: "GRÚA",
                    name: "Grúa",
                  },
                  {
                    _id: "MOTO",
                    name: "Moto",
                  },
                ]}
                onChange={handleUnitTypeParam}
              />
            ),
          };
        }
        return item;
      });
    } else if (fleetMaintenanceTable.type === "incidence") {
      header = fleetIncidenceTableHeader.map((item) => {
        if (item.name === "Unidad") {
          return {
            ...item,
            name: (
              <OneOptionTableFilter
                label={"Unidad"}
                name={"unit"}
                placeholder={""}
                options={fleetsUnitOptions}
                onChange={handleUnitParam}
              />
            ),
          };
        } else if (item.name === "Tipo de unidad") {
          return {
            ...item,
            name: (
              <OneOptionTableFilter
                label={"Tipo de unidad"}
                name={"unitType"}
                placeholder={""}
                options={[
                  {
                    _id: "All",
                    name: "Todos",
                  },
                  {
                    _id: "GRÚA",
                    name: "Grúa",
                  },
                  {
                    _id: "MOTO",
                    name: "Moto",
                  },
                ]}
                onChange={handleUnitTypeParam}
              />
            ),
          };
        } else if (item.name === "Chofer responsable") {
          return {
            ...item,
            name: (
              <OneOptionTableFilter
                label={"Chofer responsable"}
                name={"driver"}
                placeholder={""}
                options={internalProvidersOptions}
                onChange={handleDriverParam}
              />
            ),
          };
        }

        return item;
      });
    }

    return header;
  };

  const handleunitTypeChange = (e, setValue) => {
    const unitType = e.target.value;
    setValue("unitType", unitType);
    getinternalProviders(unitType);
  };

  const handleCreateFleetAction = () => {
    if (fleetMaintenanceTable.type === "incidence") {
      setValue3("unitType", "GRÚA");
      setValue3("registrationDate", new Date());
      getinternalProviders(watch3("unitType"));
      setOpenCreateFleetIncidenceModal(true);
    } else {
      setOpenCreateFleetMaintenanceModal(true);
    }
  };

  useEffect(() => {
    getFleetUnits();
    getUsers();
    getinternalProviders(unitTypeParam);
    getSystems();
    getMaintenanceProviders();
  }, []);

  useEffect(() => {
    loadFleetUnitOptions();
  }, [fleetUnits]);

  useEffect(() => {
    if (watch("systemId")) {
      getComponents(watch("systemId"));
    }
  }, [watch("systemId")]);

  useEffect(() => {
    if (watch2("systemId")) {
      getComponents(watch2("systemId"));
    }
  }, [watch2("systemId")]);

  return (
    <>
      <Header />
      <CreateFleetMaintenanceModal
        show={openCreateFleetMaintenanceModal}
        setValue={setValue}
        handleClose={() => {
          setOpenCreateFleetMaintenanceModal(false);
        }}
        title={"Registrar mantenimiento de flota"}
        register={register}
        errors={errors}
        handleSubmit={handleSubmit}
        options={{
          unitTypeOptions: [
            {
              _id: "Grúa",
              name: "Grúa",
            },
            {
              _id: "Moto",
              name: "Moto",
            },
          ],
          unitStatus: [
            {
              _id: "Accidentada",
              name: "Accidentada",
            },
            {
              _id: "En Funcionamiento",
              name: "En funcionamiento",
            },
          ],
          manteinanceTypeOptions: [
            {
              _id: "Preventivo",
              name: "Preventivo",
            },
            {
              _id: "Correctivo",
              name: "Correctivo",
            },
          ],
          maintenanceProvidersOptions: maintenanceProvidersOptions,
          unitOptions: chooseOnlyTows(getValues("type")),
          systemOptions: systems,
          componentOptions: components,
          adminOptions: userOptions,
          providersOptions: internalProvidersOptions,
        }}
        watch={watch}
        control={control}
        action={createFleetMaintenance}
      />

      <CreateFleetIncidenceModal
        show={openCreateFleetIncidenceModal}
        setValue={setValue3}
        handleClose={() => {
          setOpenCreateFleetIncidenceModal(false);
        }}
        title={"Registrar Incidencia de flota"}
        register={register3}
        errors={errors3}
        handleSubmit={handleSubmit3}
        options={{
          unitTypeOptions: [
            {
              _id: "GRÚA",
              name: "Grúa",
            },
            {
              _id: "MOTO",
              name: "Moto",
            },
          ],
          unitStatus: [
            {
              _id: "Accidentada",
              name: "Accidentada",
            },
            {
              _id: "En Funcionamiento",
              name: "En funcionamiento",
            },
          ],
          unitOptions: chooseOnlyTows(getValues3("unitType")),
          systemOptions: systems,
          componentOptions: components,
          adminOptions: userOptions,
          providersOptions: internalProvidersOptions,
        }}
        onChange={{
          unitType: handleunitTypeChange,
        }}
        watch={watch3}
        control={control3}
        action={createFleetIncidence}
      />

      <EditFleetIncidenceModal
        show={openEditFleetIncidenceModal}
        setValue={setValue4}
        handleClose={() => {
          setOpenEditFleetIncidenceModal((prevstate) => ({
            ...prevstate,
            isOpen: false,
          }));
        }}
        title={"Editar Seguimiento de flota"}
        register={register4}
        errors={errors4}
        options={{
          unitTypeOptions: [
            {
              _id: "GRÚA",
              name: "Grúa",
            },
            {
              _id: "MOTO",
              name: "Moto",
            },
          ],
          unitStatus: [
            {
              _id: "Accidentada",
              name: "Accidentada",
            },
            {
              _id: "En Funcionamiento",
              name: "En funcionamiento",
            },
          ],
          maintenanceProvidersOptions: maintenanceProvidersOptions,
          unitOptions: chooseOnlyTows(getValues4("unitType")),
          systemOptions: systems,
          componentOptions: components,
          adminOptions: userOptions,
          providersOptions: internalProvidersOptions,
        }}
        onChange={{
          unitType: handleunitTypeChange,
        }}
        watch={watch4}
        control={control4}
        action={editFleetIncidence}
      />

      <EditFleetMaintenanceModal
        show={openEditFleetMaintenanceModal}
        setValue={setValue2}
        handleClose={() => {
          setOpenEditFleetMaintenanceModal((prevstate) => ({
            ...prevstate,
            isOpen: false,
          }));
        }}
        title={"Editar mantenimiento de flota"}
        register={register2}
        errors={errors2}
        options={{
          unitTypeOptions: [
            {
              _id: "GRÚA",
              name: "Grúa",
            },
            {
              _id: "MOTO",
              name: "Moto",
            },
          ],
          unitStatus: [
            {
              _id: "Accidentada",
              name: "Accidentada",
            },
            {
              _id: "En Funcionamiento",
              name: "En funcionamiento",
            },
          ],
          manteinanceTypeOptions: [
            {
              _id: "Preventivo",
              name: "Preventivo",
            },
            {
              _id: "Correctivo",
              name: "Correctivo",
            },
          ],
          maintenanceProvidersOptions: maintenanceProvidersOptions,
          unitOptions: chooseOnlyTows(getValues2("type")),
          systemOptions: systems,
          componentOptions: components,
          adminOptions: userOptions,
          providersOptions: internalProvidersOptions,
        }}
        watch={watch2}
        control={control2}
        action={editFleetMaintenance}
      />
      <LoadSpinner show={isLoading} />
      <div className="service-with-container container">
        <div className="buttons-container">
          <h1 className="title-component">{`Mantenimiento de Flota`}</h1>
        </div>
        <hr />
        <div
          className="exportables-buttons-container"
          style={{
            gap: "10px",
          }}
        >
          <div
            style={{
              padding: "0px 0px",
              justifyContent: "flex-start",
              backgroundColor:
                fleetMaintenanceTable.type === "maintenance"
                  ? "#f27730"
                  : "#F7F8F9",
              border:
                fleetMaintenanceTable.type === "maintenance"
                  ? "1px solid #f27730"
                  : "1px solid #B4B5B5",
              borderRadius: "10px",
              cursor: "pointer",
            }}
            onClick={() => handleTableTypeSelected("maintenance")}
          >
            <h6
              style={{
                color:
                  fleetMaintenanceTable.type === "maintenance"
                    ? "#fff"
                    : "#000",
                fontSize: "16px",
                fontWeight: "600",
                padding: "4px 10px",
                textAlign: "center",
              }}
            >
              Mantenimiento de flota
            </h6>
          </div>
          <div
            style={{
              padding: "0px 0px",
              justifyContent: "flex-start",
              backgroundColor:
                fleetMaintenanceTable.type === "incidence"
                  ? "#f27730"
                  : "#F7F8F9",
              border:
                fleetMaintenanceTable.type === "incidence"
                  ? "1px solid #f27730"
                  : "1px solid #B4B5B5",
              borderRadius: "10px",
              cursor: "pointer",
            }}
            onClick={() => handleTableTypeSelected("incidence")}
          >
            <h6
              style={{
                color:
                  fleetMaintenanceTable.type === "incidence" ? "#fff" : "#000",
                fontSize: "16px",
                fontWeight: "600",
                padding: "4px 10px",
                textAlign: "center",
              }}
            >
              Incidencia de flota
            </h6>
          </div>
        </div>
        <hr
          style={{
            marginBottom: "0px",
          }}
        />
        <div className="breadcrumb-container">
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "79%",
                padding: "0px 0px",
                justifyContent: "flex-start",
              }}
            >
              <ActionButton
                style={{
                  height: "50%",
                }}
                label={
                  fleetMaintenanceTable.type === "incidence"
                    ? "Registrar Incidencia"
                    : "Registrar mantenimiento"
                }
                icon={"plus"}
                action={() => {
                  handleCreateFleetAction();
                }}
              />
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <FilterDatePicker
                bootstrap={"col-12 col-md-2"}
                label={"Desde"}
                type={"date"}
                name={"dateFrom"}
                placeholder={""}
                onChange={handleSinceDateChange}
                value={dateFrom}
                disabled={fleetMaintenanceTable?.isLoading}
              />
              <FilterDatePicker
                bootstrap={"col-12 col-md-2"}
                label={"Hasta"}
                type={"date"}
                name={"dateTo"}
                placeholder={""}
                onChange={handleUntilDateChange}
                value={dateTo}
                disabled={fleetMaintenanceTable?.isLoading}
              />
            </div>
          </div>
        </div>
        {fleetMaintenanceTable.type === "maintenance" && (
          <FleetMaintenanceTable
            header={loadMaintenanceHeaderFilters()}
            data={fleetMaintenanceTable}
            handlePageChange={handlePageChange}
            tableRef={tableRef}
            dateFrom={dateFrom}
            dateTo={dateTo}
            action={handleEditMaintenance}
          />
        )}

        {fleetMaintenanceTable.type === "incidence" && (
          <FleetIncidenceTable
            header={loadMaintenanceHeaderFilters()}
            data={fleetMaintenanceTable}
            handlePageChange={handlePageChange}
            tableRef={tableRef}
            dateFrom={dateFrom}
            dateTo={dateTo}
            action={handleEditIncidence}
          />
        )}
      </div>
    </>
  );
};

export default FleetMaintenance;
